import ToolFrameBase from './ToolFrameBase';
import Shortcut from '../utils/Shortcut';
import { type IToolActionInput, type IToolEnabledInput } from './Tool';

class ToolFramePrevious extends ToolFrameBase {
  static toolName = 'Previous frame';
  static shortcut = new Shortcut('<,Shift+,,Cmd+Shift+,,');

  static action({ controller }: IToolActionInput) {
    const frame = this.findNextOrPreviousFrame(controller.canvas, 'previous');
    this.zoomToFrame(frame, controller);
  }

  static enabled({ controller }: IToolEnabledInput) {
    return !!controller.hasFrames();
  }
}

export default ToolFramePrevious;
